import { render, staticRenderFns } from "./shopMobStarSubjectSetting.vue?vue&type=template&id=474ac4e5&"
import script from "./shopMobStarSubjectSetting.vue?vue&type=script&lang=js&"
export * from "./shopMobStarSubjectSetting.vue?vue&type=script&lang=js&"
import style0 from "./shopMobStarSubjectSetting.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports